import React from 'react';
import { Box } from '@mui/material';
import type { Priority, Criticality } from './types';

const PRIORITY_BG: Record<Exclude<Priority, 'none'>, string> = {
  P1: 'var(--color-danger-bg, #FEF2F2)',
  P2: 'var(--color-warning-bg, #FEFCE8)',
  P3: 'var(--color-bg-tertiary, #EDEDE8)',
};

const CRITICALITY_FG: Record<Criticality, string> = {
  critical: 'var(--color-danger, #DC2626)',
  high: 'var(--color-warning, #CA8A04)',
  medium: 'var(--color-text-secondary, #4B4B47)',
  low: 'var(--color-text-muted, #8A8A85)',
};

interface Props {
  priority: Priority;
  /** May be absent in malformed API rows — rendered defensively below. */
  criticality?: Criticality;
}

const PriorityBadge: React.FC<Props> = ({ priority, criticality }) => {
  if (priority === 'none') return null;
  return (
    <Box
      component="span"
      data-priority={priority}
      data-criticality={criticality}
      sx={{
        display: 'inline-flex', alignItems: 'center', gap: '4px',
        px: '6px', height: 20, borderRadius: '4px',
        fontSize: '11px', fontWeight: 700, letterSpacing: '0.02em',
        fontFamily: 'var(--font-mono, monospace)',
        bgcolor: PRIORITY_BG[priority],
        color: criticality ? CRITICALITY_FG[criticality] : 'var(--color-text-secondary, #4B4B47)',
        whiteSpace: 'nowrap',
      }}
    >
      {criticality ? `${priority} · ${criticality.toUpperCase()}` : priority}
    </Box>
  );
};

export default PriorityBadge;
